import { useState, useEffect } from 'react';
import '../Components/Styles/compteClient.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

import { LuUser } from "react-icons/lu";
import { MdOutlineEditLocationAlt } from "react-icons/md";
import { LuShoppingBag } from "react-icons/lu";
import { MdBackupTable } from "react-icons/md";
import { RiLogoutBoxRLine } from "react-icons/ri";
import TableauDeBord from './TableauDeBord';

function Commandes({ user, selectedSection }) {
  const [commandes, setCommandes] = useState([]);
  const [moisFiltre, setMoisFiltre] = useState("");

  useEffect(() => {
    if (selectedSection === "commandes") {
      fetch(`https://opale-nutrition.com/api/recup_commandes.php?email=${user.email}`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) setCommandes(data);
        })
        .catch((err) => console.error("Erreur lors du chargement des commandes", err));
    }
  }, [selectedSection, user.email]);

  const commandesFiltrees = commandes.filter((cmd) => {
    if (!moisFiltre) return true;
    const moisCommande = new Date(cmd.date).toISOString().slice(0, 7);
    return moisCommande === moisFiltre;
  });

  const moisDisponibles = [
    ...new Set(commandes.map((cmd) => new Date(cmd.date).toISOString().slice(0, 7))),
  ];

  return (
    <div className="client-container">
      <h4>Mes Commandes</h4>

      {/* Filtre par mois */}
      {moisDisponibles.length > 0 && (
        <div style={{ marginBottom: "15px" }}>
          <label>Filtrer par mois : </label>
          <select value={moisFiltre} onChange={(e) => setMoisFiltre(e.target.value)}>
            <option value="">Toutes</option>
            {moisDisponibles.map((mois) => (
              <option key={mois} value={mois}>
                {new Date(mois + "-01").toLocaleDateString("fr-FR", {
                  month: "long",
                  year: "numeric",
                })}
              </option>
            ))}
          </select>
        </div>
      )}

      {commandesFiltrees.length === 0 ? (
        <p>Aucune commande trouvée.</p>
      ) : (
        commandesFiltrees.map((cmd) => (
          <div key={cmd.reference} className='commandes-box'>
            <div className='commandes-label'>
              <div className='commandes-ref'>Réf : {cmd.reference}</div>
              <div className='commandes-date'>Date : {new Date(cmd.date).toLocaleDateString("fr-FR")}</div>
              <div className='commandes-statut'>Statut : {cmd.statut}</div>
              <div className='commandes-livraison'>Livraison : {cmd.livraison_mode} ({cmd.deliveryCost?.toFixed(2)} €)</div>
              <div className='commandes-total'>Total : {cmd.total?.toFixed(2)} €</div>
            </div>

            {/* Produits */}
            <div className='produit-box'>
              {Array.isArray(cmd.cart) && cmd.cart.length > 0 ? (
                cmd.cart.map((item) => (
                  <div className='produit-items' key={item.variante_option_id}>
                    {/* Image produit cliquable */}
                    <a href={`/produit/${item.produit_id}`}>
                      <img className='produit-img' src={`/static/media/${item.image}`} alt={item.nom}/>
                    </a>
                    {/* Infos produit */}
                    <div className='produit-desc'>
                      <a href={`/produit/${item.produit_id}`}>{item.nom}</a>
                      <p className='produit-qte'>Qté : {item.quantity}</p>
                    </div>
                    <div className='produit-total'>{item.price?.toFixed(2)} €</div>
                  </div>
                ))
              ) : (
                <p>Aucun produit dans cette commande</p>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

function CompteClient() {
  const [selectedSection, setSelectedSection] = useState('profil');
  const { user } = useAuth();
  const { logout } = useAuth();
  const [addresses, setAddresses] = useState([]);
  const [editingAddress, setEditingAddress] = useState(null);
  const navigate = useNavigate();

  const handleAddAddress = (e) => {
  e.preventDefault();
  const form = e.target;
  
  const newAddress = {
    nom_adresse: form.nom_adresse.value,
    rue: form.addressLine1.value,
    code_postal: form.postalCode.value,
    ville: form.city.value,
    country: form.country.value || 'FR'
  };

  fetch('https://opale-nutrition.com/api/adresses.php', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(newAddress)
  })
  .then(res => res.json())
  .then(data => {
    if (data.success) {
        form.reset();
        fetch('https://opale-nutrition.com/api/adresses.php', {
            method: 'GET',
            credentials: 'include',
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) setAddresses(data.adresses);
        })
        .catch(err => console.error("Erreur lors du rechargement des adresses", err));
    } else {
        alert("Erreur : " + data.message);
    }
})
  .catch(() => alert("Erreur lors de l’enregistrement"));
};
    
   useEffect(() => {
  if (selectedSection === 'adresses') {
    fetch('https://opale-nutrition.com/api/adresses.php', {
      method: 'GET',
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          console.log("Adresses reçues :", data.adresses); 
          setAddresses(data.adresses);
        }
      })
      .catch(err => console.error("Erreur lors du chargement des adresses", err));
  }
}, [selectedSection]);

    const handleDeleteAddress = (id) => {
      if (!window.confirm("Voulez-vous vraiment supprimer cette adresse ?")) return;

      fetch('https://opale-nutrition.com/api/adresses.php', {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setAddresses(prev => prev.filter(adresse => adresse.id !== id));
          } else {
            alert("Erreur lors de la suppression : " + data.message);
          }
        })
        .catch(() => alert("Erreur réseau lors de la suppression"));
    };

    const handleUpdateAddress = (e) => {
      e.preventDefault();
      const form = e.target;

      const updatedAddress = {
        id: editingAddress.id,
        nom_adresse: form.nom_adresse.value,
        rue: form.addressLine1.value,
        code_postal: form.postalCode.value,
        ville: form.city.value,
        country: form.country.value || 'FR'
      };
    
      fetch('https://opale-nutrition.com/api/adresses.php', {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedAddress)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setEditingAddress(null);
            fetch('https://opale-nutrition.com/api/adresses.php', {
              method: 'GET',
              credentials: 'include',
            })
              .then(res => res.json())
              .then(data => {
                if (data.success) setAddresses(data.adresses);
              });
          } else {
            alert("Erreur : " + data.message);
          }
        });
    };

    const handleLogout = () => {
    fetch('https://opale-nutrition.com/api/logout.php', {
      method: 'POST',
      credentials: 'include',
    })
      .then(() => {
        logout(); 
        navigate('/login');
      })
      .catch((error) => console.error('Erreur de déconnexion:', error));
  };

    const renderContent = () => {
      switch (selectedSection) {
        case 'profil':
          return (
            <div className="profil-container">
              <div className="ip-container profil-container-design">
                <h4>Infos personnelles</h4>
                <div className="ip-nom"><strong>Pseudo :</strong> {user.username}</div>
                <div className="ip-email"><strong>Email :</strong> {user.email}</div>
                <div className="ip-num"><strong>Numero :</strong></div>
              </div>
              <div className="cpc-container profil-container-design">
                <h4>Classement par catégorie</h4>
                <div className="list-categories">
                  <p className="weight">Weight</p>
                  <p className="run">Run</p>
                </div>
              </div>
              <div className="pr-container profil-container-design">
                <h4>PR</h4>
                <div className="col-list">
                  <p className="weight">Weight</p>
                  <p className="run">Run</p>
                </div>
              </div>
              
            </div>
          );
        case 'adresses':
        return (
          <div className="client-container">
            <h4>Mes Adresses</h4>
            {!editingAddress && (
              <form onSubmit={handleAddAddress} className="form-client">
                <div className="input-client-all">
                  <input className="input-client" placeholder="Nom de l’adresse" name="nom_adresse" type="text" required/>
                  <input className="input-client" placeholder="Rue" name="addressLine1" type="text" required/>
                  <input className="input-client" placeholder="Code Postal" name="postalCode" type="text" required/>
                  <input className="input-client" placeholder="Ville" name="city" type="text" required/>
                  <input className="input-client" placeholder="Pays" name="country" type="text"/>
                </div>
                <button type="submit">Ajouter</button>
              </form>
            )}
            {editingAddress && (
              <form onSubmit={handleUpdateAddress} className="form-client">
                <div className="input-client-all">
                  <input className="input-client" defaultValue={editingAddress.nom_adresse || ""} name="nom_adresse" type="text" required/>
                  <input className="input-client" defaultValue={editingAddress.rue || editingAddress.shippingAddress?.addressLine1 || ""} name="addressLine1" type="text" required/>
                  <input className="input-client" defaultValue={editingAddress.code_postal || editingAddress.shippingAddress?.postalCode || ""} name="postalCode" type="text" required/>
                  <input className="input-client" defaultValue={editingAddress.ville || editingAddress.shippingAddress?.city || ""} name="city" type="text" required/>
                  <input className="input-client" defaultValue={editingAddress.country || editingAddress.shippingAddress?.country || "FR"} name="country" type="text"/>
                </div>
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setEditingAddress(null)}>Annuler</button>
              </form>
            )}

            {/* Liste des adresses */}
            <div className="liste-adresses">
              {addresses.length === 0 ? (
                <p>Aucune adresse enregistrée.</p>
              ) : (
                addresses.map((adresse) => {
                  const label = adresse.label || adresse.nom_adresse || "Adresse";
                  const addr = adresse.shippingAddress || {};
                  return (
                    <div className="carte-adresse" key={adresse.id}>
                      <div className="carte-adresse-client">
                        <h5>{label}</h5>
                        <p>{addr.addressLine1 || adresse.rue || ""}</p>
                        <p>
                          {addr.postalCode || adresse.code_postal || ""}{" "}
                          {addr.city || adresse.ville || ""}
                        </p>
                        <p>{addr.country || adresse.country || "FR"}</p>
                      </div>
                      <div className="carte-adresse-changement">
                        <button className="carte-adresse-remove" onClick={() => handleDeleteAddress(adresse.id)}>
                          Supprimer
                        </button>
                        <button className="carte-adresse-remove" onClick={() => setEditingAddress({  ...adresse,  nom_adresse: adresse.nom_adresse || adresse.label || "Adresse"})}>
                          Modifier
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        );
        case 'commandes':
          return <Commandes user={user} selectedSection={selectedSection} />;
        
        case 'tableau-de-bord': return <TableauDeBord />;

        default:
          return <div>Sélectionnez une option à gauche.</div>;
      }
    };

    return (
      <div className="compte-client-container">
          <div className="left-container">
              <div className="left-infos">
                {user &&
                  <div className="nom">{user.username}</div>
                  }
                  <div className="details">
                      <div className={`profil ${selectedSection === 'profil' ? 'active' : ''}`} onClick={() => setSelectedSection('profil')}><LuUser size={25}/> Mon Profil</div>
                      <div className={`adresses ${selectedSection === 'adresses' ? 'active' : ''}`} onClick={() => setSelectedSection('adresses')}><MdOutlineEditLocationAlt size={25}/> Mes Adresses</div>
                      <div className={`commandes ${selectedSection === 'commandes' ? 'active' : ''}`} onClick={() => setSelectedSection('commandes')}><LuShoppingBag size={25}/> Mes Commandes</div>
                      {user.role === 'AdminLomi' && 
                        <div className={`tableau-de-bord ${selectedSection==='tableau-de-bord'?'active':''}`} onClick={()=>setSelectedSection('tableau-de-bord')}><MdBackupTable size={25}/> Tableau de Bord</div>
                      }
                      <div className="logout" onClick={handleLogout}><RiLogoutBoxRLine size={25}/> Deconnexion</div>
                  </div>
              </div>
          </div>
          <div className="right-container">
              {renderContent()}
          </div>  
      </div>
    );
  }

export default CompteClient;